<template>
  <div>
    <QuoteOverviewGrid />
  </div>
</template>

<script>
import QuoteOverviewGrid from "@/modules/quotes/components/overview/QuoteOverviewGrid";

export default {
  components: {
    QuoteOverviewGrid,
  },
};
</script>
